export const isConfirmActionTextValid = (
  enteredConfirmText: string,
  confirmText: string,
  hideConfirmInput?: boolean,
) => {
  if (hideConfirmInput) return true;

  return enteredConfirmText.toLowerCase() === confirmText.toLowerCase();
};
